import { MUI } from 'components'

import { StatsCardType } from './statsCard.types'

import { theme } from 'theme'

const StatsCard = ({
  icon,
  label,
  value,
  backgroundColor = '#2196f3',
}: StatsCardType) => {
  return (
    <MUI.Paper variant="outlined">
      <MUI.Box p={3} display="flex" alignItems="center" gap={2} $width="100%">
        <MUI.Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={48}
          height={48}
          borderRadius={2}
          $backgroundColor={backgroundColor}
          color="white"
        >
          {icon}
        </MUI.Box>

        <MUI.Box display="flex" flexDirection="column" flex={1} $minWidth={0}>
          <MUI.Typography
            variant="h6"
            fontWeight={600}
            color={theme.palette.text.primary}
            $whiteSpace="nowrap"
            $overflow="hidden"
            $textOverflow="ellipsis"
          >
            {value}
          </MUI.Typography>
          <MUI.Typography
            variant="caption"
            color={theme.palette.text.secondary}
            fontWeight={500}
            $whiteSpace="nowrap"
            $overflow="hidden"
            $textOverflow="ellipsis"
          >
            {label}
          </MUI.Typography>
        </MUI.Box>
      </MUI.Box>
    </MUI.Paper>
  )
}

export default StatsCard
